export default __webpack_public_path__ + "static/media/success_sync.66715972.svg";